export const seedConstants={
  FETCH_ALL_SEEDS_BEGIN: 'FETCH_ALL_SEEDS_BEGIN',
  FETCH_ALL_SEEDS_SUCCESS:'FETCH_ALL_SEEDS_SUCCESS',
  FETCH_ALL_SEEDS_ERROR:'FETCH_ALL_SEEDS_ERROR'
};

